import { fetchWithHandling } from "utils/common-utils";
import { CreateModelTypeRq, CreateModelTypeRs, GetModelTypeRs, UpdateModelTypeRq, UpdateModelTypeRs } from "utils/interfaces";

const API_URL = `${process.env.REACT_APP_BACKEND_API_PREFIX}/api/v1/model-types`

export const getAll = async (
    jwtToken: string,
    onSessionExpired: () => void
): Promise<GetModelTypeRs[]> => {
    try {
        const jsonData = await fetchWithHandling(
            API_URL,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            },
            () => {
                onSessionExpired();
            }
        );
        return jsonData as GetModelTypeRs[];
    } catch (error) {
        return [];
    }
}

export const create = async (
    jwtToken: string,
    onSessionExpired: () => void,
    data: CreateModelTypeRq,
): Promise<CreateModelTypeRs | null> => {
    try {
        const jsonData = await fetchWithHandling(
            API_URL,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: JSON.stringify(data),
            },
            () => {
                onSessionExpired();  // Chiamata al callback per la gestione della scadenza della sessione
            }
        );
        return jsonData as CreateModelTypeRs;
    } catch (error) {
        return null;
    }
};

export const update = async (
    jwtToken: string,
    onSessionExpired: () => void,
    data: UpdateModelTypeRq,
): Promise<UpdateModelTypeRs | null> => {
    try {
        const jsonData = await fetchWithHandling(
            API_URL,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: JSON.stringify(data),
            },
            () => {
                onSessionExpired();  // Chiamata al callback per la gestione della scadenza della sessione
            }
        );
        return jsonData as UpdateModelTypeRs;
    } catch (error) {
        return null;
    }
};

export const deleteModelType = async (
    jwtToken: string,
    onSessionExpired: () => void,
    id: number
): Promise<boolean> => {
    try {
        await fetchWithHandling(
            `${API_URL}/${id}`,
            {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            },
            () => {
                onSessionExpired();  // Chiamata al callback per la gestione della scadenza della sessione
            }
        );
        return true;
    } catch (error) {
        return false;
    }
};